import styled from "styled-components";

export const StyledProgramasFormPmePage = styled.section`
.cardTabPme{
min-height: calc(100vh - 300px);
}

.cardTabPmePerfil{
min-height: calc(100vh - 70%);
}

.toggleporc input[type=checkbox] {
    width: 100% !important;
}
`;


